module.exports = __webpack_public_path__ + "static/media/triangle.571cbb9c.svg";